define.alias("checkout/components/seamless-checkout/review-changes-button", "settings/components/seamless-checkout/review-changes-button");